export const ANIMATION_START_Y = 30;
